import { makeStyles } from '@material-ui/core/styles'
import { pageContentHorizontalGutters } from 'lib/styles/page-content-gutters'

export const useStyles = makeStyles(theme => ({
  root: pageContentHorizontalGutters(theme, {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    sm: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      marginBottom: '60px',
    },
  }),
  tabContent: {
    width: '100%',
    boxSizing: 'border-box',
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(1.5),
    },
  },
  emptyStateContent: {
    padding: theme.spacing(4, 2),
  },
  groupEventsWrapper: {
    marginTop: 0,
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(8),
    },
  },
  tipBannerWrapper: {
    width: '100%',
    boxSizing: 'border-box',
    marginBottom: theme.spacing(3),
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(1.5),
      marginBottom: theme.spacing(2.5),
    },
  },
  disabledActionTile: {
    backgroundColor: theme.palette.grey[200],
  },
}))
